export enum FieldOrigin {
  None = 0,
  Property = 1,
  Relation = 2,
  Local = 3,
}
